import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";

class VerifyEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      error: null
    };
  }
  async componentDidMount() {
    const url =
      "https://qeyrfqi5id.execute-api.us-east-1.amazonaws.com/dev/users/verify-email";
    const emailToken = window.location.pathname.replace(
      /\/verify-email\/?/,
      ""
    );
    if (emailToken.length < 5) {
      // this is a bogus URL—redirect
      return this.setState({
        redirect: true
      });
    }
    const data = {
      emailToken
    };
    try {
      const result = await axios.post(url, data);
      const { jwt } = result.data;
      localStorage.setItem("token", jwt);
      this.setState({
        redirect: true
      });
    } catch (error) {
      console.log(error);
      this.setState({
        error: "Something went wrong!"
      });
    }
  }
  render() {
    const { redirect, error } = this.state;
    if (redirect) {
      return <Redirect to="/" />;
    } else if (error) {
      return (
        <div style={{ textAlign: "center", marginTop: "3rem" }}>
          <p>{this.state.error}</p>
          <div style={{ marginTop: "2rem" }}>
            <Link
              style={{ textDecoration: "none" }}
              to="/contact"
              className="btn"
            >
              Click here to contact support!
            </Link>
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ textAlign: "center", marginTop: "3rem" }}>
          <p>Verifying email</p>
        </div>
      );
    }
  }
}

export default VerifyEmail;



// WEBPACK FOOTER //
// ./src/components/VerifyEmail.js